export default "__VITE_ASSET__B1w_pUmr__"